import request from '../utils/request.js'

export default {
  // 获取系统模板列表
  getList (params) {
    return request.post(`system_template/lists`, params).then(res => res.data)
  },
  // 获取模板详情
  details (params) {
    return request.post(`system_template/details`, params).then(res => res.data)
  },
  // 获取分类列表
  categories () {
    return request.post(`system_template/categories`).then(res => res.data)
  },
  // 添加模板
  add (params) {
    return request.post(`system_template/add`, params).then(res => res.data)
  },
  // 编辑模板
  edit (params) {
    return request.post(`system_template/edit`, params).then(res => res.data)
  },
  // 删除模板
  delete (params) {
    return request.post(`system_template/del`, params).then(res => res.data)
  },
  // 切换状态
  toggleStatus (params) {
    return request.post(`system_template/toggle_status`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/systemTemplate.js